/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable no-case-declarations */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import {
  fetchAtivaDesativaUsuarioOrganizacao,
  getExisteEmailTenant,
  getUsers,
  getUsersOrgId,
  postCriaUsuarioTenant,
  putUsersOrgIdEdit,
} from '../../services/Users/getUsers'
import { IFormInputs } from '../NewUsers/NewUser.interface'

// PD-0004: papeis que acompanham VARIOS vendedores (lista de CPFs) — os demais usam 1 CPF ou nenhum.
export const papelMultiVendedor = (papel: string) =>
  papel === 'COORDENADOR' || papel === 'ASSISTENTE'

// So digitos, sem vazios e sem repetidos; descarta o que nao tem 11 digitos (o backend rejeita).
export const normalizaCpfs = (cpfs: string[]) =>
  cpfs
    .map(cpf => cpf.replace(/\D/g, ''))
    .filter(cpf => cpf.length === 11)
    .filter((cpf, index, lista) => lista.indexOf(cpf) === index)

export const useUsers = () => {
  const navigate = useNavigate()
  const goToPage = (id: number) => {
    navigate(`/produto/${id}`)
  }

  const { control } = useForm<IFormInputs>({
    mode: 'onChange',
    defaultValues: {
      isAdmin: false,
    },
  })

  const XTENANTID = localStorage.getItem('X-TENANT-ID')
  const useOrg = XTENANTID != null ? XTENANTID.slice(1, -1) : ' '

  const [searchValue, setSearchValue] = useState('')
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [isShowSend, setIsShowSend] = useState(false)

  const [check, setCheck] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [users, setUsers] = useState<GetUsersType>({} as GetUsersType)
  const [usersOrgId, setUsersOrgId] = useState<GetUsersOrgIdType>(
    {} as GetUsersOrgIdType
  )

  const [isLoading, setIsLoading] = useState(true)
  const [modalInativar, setModalInativar] = useState(false)
  const [status, setStatus] = useState(Boolean)
  const [userId, setUserId] = useState<number>(0)
  const [edicao, setEdicao] = useState(false)

  const [searchPapel, setSearchPapel] = useState<string>('')
  const [searchCpf, setSearchCpf] = useState('')
  // PD-0004: CPFs acompanhados, na edicao de COORDENADOR/ASSISTENTE.
  const [searchCpfs, setSearchCpfs] = useState<string[]>([''])
  const [idUserOrg, setIdUserOrg] = useState<number>(0)
  const [campoObrigatorioCpf, setCampoObrigatorioCpf] = useState(false)
  const [campoPapel, setCampoPapel] = useState(false)

  // criação de usuário do tenant (modal "Novo usuário")
  const [novoUsuario, setNovoUsuario] = useState(false)
  const [novoNome, setNovoNome] = useState('')
  const [novoEmail, setNovoEmail] = useState('')
  const [novoSenha, setNovoSenha] = useState('')
  const [novoConfirmarSenha, setNovoConfirmarSenha] = useState('')
  const [novoPapel, setNovoPapel] = useState<PapelOrganizacaoType>('VENDEDOR')
  const [novoCpf, setNovoCpf] = useState('')
  // PD-0004: CPFs dos vendedores acompanhados por COORDENADOR/ASSISTENTE.
  const [novoCpfs, setNovoCpfs] = useState<string[]>([''])
  const [novoErro, setNovoErro] = useState('')
  const [salvandoNovo, setSalvandoNovo] = useState(false)
  // e-mail já cadastrado no Master: nesse caso só vinculamos (sem campos de senha)
  const [emailJaExiste, setEmailJaExiste] = useState(false)
  const [verificandoEmail, setVerificandoEmail] = useState(false)

  const abreFechaNovoUsuario = () => {
    setNovoErro('')
    setNovoNome('')
    setNovoEmail('')
    setNovoSenha('')
    setNovoConfirmarSenha('')
    setNovoPapel('VENDEDOR')
    setNovoCpf('')
    setNovoCpfs([''])
    setEmailJaExiste(false)
    setVerificandoEmail(false)
    setNovoUsuario(estado => !estado)
  }

  const emailValido = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

  // ao editar o e-mail volta ao fluxo padrão (com senha) até a nova verificação
  const handleChangeNovoEmail = (value: string) => {
    setNovoEmail(value)
    setEmailJaExiste(false)
  }

  // verifica (no blur) se o e-mail já existe para esconder/exibir os campos de senha
  const verificaEmailExistente = async () => {
    const email = novoEmail.trim()
    if (!emailValido(email)) {
      setEmailJaExiste(false)
      return
    }
    setVerificandoEmail(true)
    const existe = await getExisteEmailTenant(useOrg, email)
    setVerificandoEmail(false)
    setEmailJaExiste(existe)
  }

  const fetchUsers = async () => {
    setIsLoading(true)
    const result = await getUsers(searchValue, useOrg, currentPage)
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setUsers(result)
    }
  }

  const handleCriaUsuario = async (fechaModal: () => void) => {
    setNovoErro('')

    if (!novoNome.trim()) {
      setNovoErro('Informe o nome.')
      return
    }
    if (!emailValido(novoEmail.trim())) {
      setNovoErro('Informe um e-mail válido.')
      return
    }
    // senha só é exigida ao criar usuário novo; e-mail existente é apenas vinculado
    if (!emailJaExiste) {
      if (!novoSenha || !novoConfirmarSenha) {
        setNovoErro('Informe a senha e a confirmação.')
        return
      }
      if (novoSenha !== novoConfirmarSenha) {
        setNovoErro('As senhas não coincidem.')
        return
      }
      // mesma regra do backend (PasswordValidator): 8+ chars, maiúscula, minúscula e número
      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(novoSenha)) {
        setNovoErro(
          'Senha inválida: mínimo 8 caracteres, com maiúscula, minúscula e número.'
        )
        return
      }
    }
    const cpfDigitos = novoCpf.replace(/\D/g, '')
    if (novoPapel === 'VENDEDOR' && cpfDigitos.length !== 11) {
      setNovoErro('CPF é obrigatório para vendedor e deve conter 11 dígitos.')
      return
    }
    // COORDENADOR/ASSISTENTE (PD-0004): ao menos um CPF, todos com 11 dígitos.
    const cpfsDigitos = normalizaCpfs(novoCpfs)
    if (papelMultiVendedor(novoPapel) && cpfsDigitos.length === 0) {
      setNovoErro(
        'Informe ao menos um CPF de vendedor, com 11 dígitos cada, para Coordenador e Assistente.'
      )
      return
    }

    setSalvandoNovo(true)
    const result = await postCriaUsuarioTenant(useOrg, {
      nome: novoNome.trim(),
      email: novoEmail.trim(),
      papelOrganizacao: novoPapel,
      senha: emailJaExiste ? '' : novoSenha,
      senhaConfirmacao: emailJaExiste ? '' : novoConfirmarSenha,
      cpfcnpj: novoPapel === 'VENDEDOR' ? cpfDigitos : undefined,
      cpfcnpjs: papelMultiVendedor(novoPapel) ? cpfsDigitos : undefined,
    })
    setSalvandoNovo(false)

    if ('info' in result) {
      toast.success(result.info)
      fechaModal()
      await fetchUsers()
      return
    }
    setNovoErro(result.message)
    toast.error(result.message)
  }

  const abreFechaEdicao = () => setEdicao(!edicao)

  const fetchUsersOrgId = async (
    id: number,
    papelOrganizacao: PapelOrganizacaoType
  ) => {
    setIsLoading(true)
    const result = await getUsersOrgId(useOrg, id)
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setUsersOrgId(result)
      setIdUserOrg(id)
      localStorage.setItem(
        'editUserPapelOrganizacao',
        JSON.stringify(papelOrganizacao)
      )

      localStorage.setItem('editUserCPF', JSON.stringify(result.cpfcnpj))
      localStorage.setItem(
        'editUserCPFs',
        JSON.stringify(
          result.cpfcnpjs && result.cpfcnpjs.length > 0 ? result.cpfcnpjs : ['']
        )
      )
      abreFechaEdicao()
    }
  }
  const organizacaoEditRequestDTO = {
    cpfcnpj: searchPapel === 'VENDEDOR' ? searchCpf : ' ',
    // PD-0004: a lista so vai preenchida nos papeis multi-vendedor. Nos demais vai vazia, e o
    // backend limpa os vinculos de CPF — importante numa troca de papel.
    cpfcnpjs: papelMultiVendedor(searchPapel) ? normalizaCpfs(searchCpfs) : [],
    papelOrganizacao: searchPapel.toUpperCase(),
  }
  const fetchUsersOrgIdEdit = async (id: number) => {
    setIsLoading(true)
    const result = await putUsersOrgIdEdit(
      useOrg,
      id,
      organizacaoEditRequestDTO
    )
    if ('info' in result) {
      toast.success(result.info)
      const timer = setTimeout(() => {
        window.location.reload()
      }, 500)
      // Limpa o timer se o componente desmontar
      return () => clearTimeout(timer)
    }
    toast.error(result.message)
  }

  const fetchAtivaInativaUserOrganizacao = async () => {
    setIsLoading(true)
    const result = await getUsers(searchValue, useOrg, currentPage)
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setUsers(result)
    }
  }

  const acaoUsuario = async (acao: string) => {
    setIsLoading(true)
    const result = await fetchAtivaDesativaUsuarioOrganizacao(
      userId,
      useOrg,
      acao
    )
    setIsLoading(false)
    if ('info' in result) {
      toast.success(result.info)
      fetchUsers()

      return
    }
    if ('message' in result) {
      toast.error(result.message)
    }
  }

  const showFilter = () => setIsShowFilter(!isShowFilter)
  const showSend = () => setIsShowSend(!isShowSend)
  const showInativar = () => setModalInativar(!modalInativar)
  const desativar = () => acaoUsuario('desativar')
  const ativar = () => acaoUsuario('ativar')

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      fetchUsers()
    }
  }

  const handleClear = () => {
    localStorage.removeItem('editUserPapelOrganizacao')
    localStorage.removeItem('editUserCPF')
    localStorage.removeItem('editUserCPFs')
  }

  const handleValidaEdicao = (id: number, fechaModal: () => void) => {
    // Reseta os estados de validação para cada chamada
    setCampoObrigatorioCpf(false)
    setCampoPapel(false)

    switch (searchPapel) {
      case 'VENDEDOR':
        if (searchCpf.length <= 13) {
          setCampoObrigatorioCpf(true)
        } else {
          fetchUsersOrgIdEdit(id)
          fechaModal()
        }

        break

      // PD-0004: coordenador e assistente exigem ao menos um CPF valido na lista.
      case 'COORDENADOR':
      case 'ASSISTENTE':
        if (normalizaCpfs(searchCpfs).length === 0) {
          setCampoObrigatorioCpf(true)
        } else {
          fetchUsersOrgIdEdit(id)
          fechaModal()
        }

        break

      case 'ADMINISTRADOR':
        // Não requer CPF para administrador, limpa o campo CPF
        setSearchCpf('')
        // Delay para ação, se necessário
        const timer = setTimeout(() => {
          fetchUsersOrgIdEdit(id)
          fechaModal()
        }, 1000)
        // Limpa o timer se o componente desmontar
        return () => clearTimeout(timer)

      default:
        // Caso não seja nem 'VENDEDOR' nem 'ADMINISTRADOR'
        setCampoPapel(true)
        break
    }
  }

  const handleChangeSelectUser = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSearchPapel(event.target.value)
  }

  useEffect(() => {
    const editUserPapelOrganizacao = localStorage.getItem(
      'editUserPapelOrganizacao'
    )
    const editUserCpf = localStorage.getItem('editUserCPF')

    if (editUserPapelOrganizacao) {
      setSearchPapel(JSON.parse(editUserPapelOrganizacao))
    }
    if (editUserCpf) {
      setSearchCpf(JSON.parse(editUserCpf))
    }
    const editUserCpfs = localStorage.getItem('editUserCPFs')
    if (editUserCpfs) {
      setSearchCpfs(JSON.parse(editUserCpfs))
    }
  }, [])

  useEffect(() => {
    fetchUsers()
  }, [currentPage])

  return {
    handleClear,
    showSend,
    isShowSend,
    searchValue,
    setSearchValue,
    check,
    setCheck,
    isShowFilter,
    currentPage,
    setCurrentPage,
    users,
    fetchUsers,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,
    setIsShowSend,
    control,

    fetchAtivaInativaUserOrganizacao,
    showInativar,
    modalInativar,
    status,
    setStatus,
    ativar,
    desativar,
    setUserId,
    fetchUsersOrgId,
    usersOrgId,
    edicao,
    abreFechaEdicao,
    searchPapel,
    setSearchPapel,
    searchCpf,
    setSearchCpf,
    searchCpfs,
    setSearchCpfs,
    userId,
    idUserOrg,
    fetchUsersOrgIdEdit,
    campoObrigatorioCpf,
    setCampoObrigatorioCpf,
    handleValidaEdicao,
    campoPapel,
    setCampoPapel,
    handleChangeSelectUser,

    novoUsuario,
    abreFechaNovoUsuario,
    novoNome,
    setNovoNome,
    novoEmail,
    handleChangeNovoEmail,
    verificaEmailExistente,
    emailJaExiste,
    verificandoEmail,
    novoSenha,
    setNovoSenha,
    novoConfirmarSenha,
    setNovoConfirmarSenha,
    novoPapel,
    setNovoPapel,
    novoCpf,
    setNovoCpf,
    novoCpfs,
    setNovoCpfs,
    novoErro,
    salvandoNovo,
    handleCriaUsuario,
  }
}
